import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

type ProBadgeProps = HTMLAttributes<HTMLSpanElement>;

/**
 * Small pill that flags Pro-only features. Sits inline next to titles and
 * settings rows; uses the warning tint to read as "premium" without
 * competing with the accent color.
 */
export function ProBadge({ className, ...rest }: ProBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-pill px-2 py-[2px]',
        'bg-warning/15 text-warning',
        'text-[10px] font-semibold tracking-[0.08em] uppercase leading-none',
        className,
      )}
      {...rest}
    >
      Pro
    </span>
  );
}
